import { useMemo, useEffect, useState } from "react";
import TEXT from "localisation";
import Link from "next/link";
import logInternalLinkClick from "lib/ga/internalLinkClick";
import { ResultThumbnail } from "lib/types";
import styles from './result.module.css';
import globalStyles from '../../search.module.css';
import LazyImage from "components/LazyImage";


import interpretThumbnail from "lib/interpretThumbnail";

import Children from "./Children";
import { checkLoggedIn } from "context/context";
import { trimToLastWord } from "lib/textReducer";

type Company = {
  id: string;
  name: string;
}

type DisplayCardProps = {
  id: string;
  isAConcat: boolean;
  priority: boolean;
  searchCriteria: string;
  searchName: string;
  searchPortfolio: any; // unsure
  childIds?: any; // unsure
  visibleConcat?: any; // unsure
  updateVisibleConcat?: any; // unsure
  key?: any; // unsure
  noLazy: boolean;
  url: string;
  type: string;
  full_name: string;
  address: string[];
  place_name: string;
  displayPlaceName: boolean;
  search_rank: number;
  thumbnail: ResultThumbnail;
  sponsored: boolean;
  description: string;
  price: string;
  availability: [];
  size: string;
  size_m: string;
  use_class: string;
  rent: string;
  updated: Array<string | number>;
  resultHref: string;
  showChildren: boolean;
  resultTarget: string;
  marketedBy?: Company[];
  marketedTitle: string;
  renderChildren: boolean;
  properties: any;
  number_of_available_properties?: number;
  resultLinkRef: any;
  selected: string;
  showSponsorBadge: boolean;
  onExpand: (selection) => {};
  onMouseEnter: React.MouseEventHandler<HTMLElement>;
  onMouseLeave: React.MouseEventHandler<HTMLElement>;
  hideSearchScore?: boolean;
  displayExpandButton: boolean;
  uri: string;
  sizeMeasurementType: any;
  docType?: string;
  headline?: string;
  owners: any;
  forSale: boolean;
  mapView: boolean;
  category_code: string;
  buttons: any;
}

const DisplayCard = (props: DisplayCardProps) => {
  const {
    searchName,
    id, childIds, visibleConcat,
    noLazy,
    docType,
    full_name = "Shop to rent",
    address,
    place_name,
    displayPlaceName,
    search_rank = 0,
    thumbnail,
    sponsored,
    description,
    price,
    availability,
    size,
    use_class,
    rent,
    properties,
    number_of_available_properties,
    resultHref,
    resultLinkRef,
    resultTarget = '',
    marketedBy,
    marketedTitle = 'Marketed by',
    renderChildren = false,
    onExpand,
    selected,
    showSponsorBadge,
    onMouseEnter,
    onMouseLeave,
    hideSearchScore = false,
    displayExpandButton = true,
    uri,
    sizeMeasurementType,
    owners,
    headline,
    mapView = false,
    buttons,
    category_code
  } = props;
  const thumbnailProps = useMemo(() => {
    return interpretThumbnail(thumbnail, full_name || address, "", "", "", 600);
  }, [thumbnail, full_name]);
  const loggedIn = checkLoggedIn()

  const stylingType = docType === 'scheme' ? 'scheme' : 'property';

  const [openChildren, SetOpenChildren] = useState<boolean | null>(null);
  useEffect(() => {

    if (selected === id) {
      SetOpenChildren(true);
      setTimeout(function () {
        const elem = document.getElementById(`card-${id}`);
        let headerOffset = 120;
        if (elem) {
          let elementPosition = elem.getBoundingClientRect().top;
          let offsetPosition = elementPosition + window.scrollY - headerOffset;
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          })
        }
      }, 100);

    } else {
      SetOpenChildren(false)
    }
  }, [selected, id, renderChildren]);

  let displayHeadline = headline ? headline.trim() : '';
  if (displayHeadline && !displayHeadline.endsWith('.')) {
    displayHeadline = `${displayHeadline}.`;
  }

  const displayDescription = [displayHeadline, description].filter(Boolean).join(' ');

  return (
 
    <li className={styles.CardComponent} id={`card-${id}`}>
      <div className={stylingType === 'scheme' ? `${styles.innerContainer}  ${sponsored ? styles.schemeStyleSponsored : styles.schemeStyle}` : `${styles.innerContainer} ${styles.propertyBorder}`} >
        <article
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          onClick={(e) => {
            if (
              (e.target as HTMLElement).tagName.toUpperCase() !== "BUTTON" &&
              (e.target as HTMLElement).tagName.toUpperCase() !== "A"
            ) {
              resultLinkRef.current.click();
            }
          }}
          title={full_name}
          className={
            `
            ${mapView ? stylingType === 'scheme' ? styles.articleSchemeMap : styles.articleMap
             : stylingType === 'scheme' ? styles.articleScheme : styles.article}
            ${(marketedBy && marketedBy.length !== 0) || (owners && owners.length > 0 && loggedIn) ? '' : stylingType === 'scheme' ? styles.noRepsScheme : styles.noReps}
           `
          }

        >
          <Link href={resultHref || ''} passHref prefetch={false} legacyBehavior >
            <a
              ref={resultLinkRef}
              aria-label={address?.join(", ")}
              onClick={(e) => {
                logInternalLinkClick("Scheme Search Result", resultHref);
              }}
              target={resultTarget}
              className={styles.cardHeading}
            >
              {displayPlaceName && (
                <>
                  <h2>{place_name}</h2>
                  <h3>{full_name}</h3>

                </>
              )}

              {!displayPlaceName && address && (
                <h2 itemScope itemType="https://schema.org/Place">
                  <address title={address?.join(", ")} itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
                    <meta itemProp="streetAddress" content={address?.join(", ")} />
                    <meta itemProp="addressCounty" content="GB" />
                    <span>{address[0]}&nbsp;</span>
                    <span>
                      {address[1]}
                    </span>
                  </address>
                </h2>

              )}
            </a>
          </Link>
          
            <div className={styles.propertyType}>
              <div>{TEXT[`FILTER_CATEGORIES_${category_code}`]}</div>
            </div>

          {description && (
            <p>
              {trimToLastWord(displayDescription, 270)}
            </p>
          )}
          {docType !== 'scheme' && (
            <div className={styles.statsTray}>
              {availability && (
                <div className={styles.tagTitle}>Availability: <span>{availability.join(' / ')}</span></div>
              )}
              {size && (<>
                <div className={styles.tagTitle}>Size: <span>{size ? /^[0-9]*$/.test(size) ? parseInt(size).toLocaleString() : size : "N/A"} {sizeMeasurementType?.name}</span> </div>              </>
              )}
              {
                use_class && (
                  <div className={styles.tagTitle}>Use Class: <span>{use_class}</span> </div>
                )}
              {Boolean(rent) && (
                <div className={styles.tagTitle}>Rent: <span>{rent ? `£${parseInt(rent).toLocaleString()} pa` : "Price on Application"}</span> </div>
              )}
              {!rent && !price && (
                <div className={styles.tagTitle}>Price: <span>on application</span></div>
              )}
              {Boolean(price) && (
                <div className={styles.tagTitle}>Price: <span> {`£${parseInt(price).toLocaleString()}`}</span></div>
              )}
              {category_code && (
                <div className={`${styles.tagTitle} ${styles.noWrap}`}>Type: <span>{TEXT[`FILTER_CATEGORIES_${category_code}`]}</span></div>
              )}
            </div>

          )}
          {((marketedBy && marketedBy.length !== 0) || (owners && owners.length > 0 && loggedIn)) && (

            <div className={styles.repsContainer} >
              {marketedBy && marketedBy.length !== 0 && (
                <div>
                  <div className={styles.tagTitle}>Agents</div> 
                  <div className={styles.agentContainer}>
                    {marketedBy.map((company) => {
                      if (loggedIn) {
                        return (
                          <Link key={company.id} href={`/overview/${company.id}`} passHref prefetch={false} legacyBehavior>
                            <a
                              className={styles.marketedBy}
                              onClick={(e) => e.stopPropagation()}
                              title={"Explore " + company.name + " on Completely Retail"}
                              itemScope itemType="https://schema.org/Organization" itemProp="name"
                            >
                              {company.name}
                            </a>
                          </Link>
                        )
                      } else {
                        return (<p key={company.id} className={styles.marketedByNoLink}>{company.name}</p>)
                      }
                    }

                    )}
                  </div>
                </div>
              )}
              {loggedIn && owners && owners.length > 0 && (
                <div className={styles.ownersContainer}>
                  {owners.filter(o => Boolean(o.paying_client)).map((owner) => (
                    <Link key={owner.company_id} href={`/overview/${owner.company_id}`} passHref prefetch={false} onClick={(e) => e.stopPropagation()} title={"Explore " + owner.company_name + " on Completely Retail"}>
                      <img alt={`${owner.company_name} logo`} src={`${process.env.NEXT_PUBLIC_APP_MEDIA_URL}${owner.logo_uri}`} loading="lazy" height="auto" width="auto"></img>
                    </Link>

                  ))
                  }
                </div>
              )}
            </div>
          )}


          <div className={stylingType === 'scheme' ? `${styles.schemeImage} ${styles.thumbNail}` : styles.thumbNail}>
            <LazyImage
              {...thumbnailProps}
              priority={noLazy}
              sizes={"(min-width: 48rem) 60vw, (min-width: 21rem) 40vw, 100vw"}
              noLazy={noLazy}

            />
            {/* Dont't show if an unsponsored property */}
            {(showSponsorBadge && sponsored) && (
              <div className={styles.badgeCard}>
                <span>Featured</span>
              </div>
            )}
          </div>

        </article >

        <div className={docType === 'scheme' ? `${styles.schemeTray} ${styles.tray} ${sponsored ? styles.schemeTraySponsored : ''}` : `${styles.propertyTray} ${styles.tray}`}>

          {displayExpandButton && (
            <ul style={{ display: selected === id ? '' : 'none' }} className={styles.unitList}>

              <Children parentThubmnails={thumbnailProps} parentName={full_name}
                properties={properties || []} scheme_uri={uri} sponsored={sponsored}
                ids={childIds} searchName={searchName}
                show={(properties || []).length > 0 || visibleConcat === id || true}
                address={address?.join(", ")} sizeMeasurementType={sizeMeasurementType} />

            </ul>
          )}

          <div className={styles.trayButtons}>

            {!buttons && (
              <Link href={resultHref || ''} passHref prefetch={false} >
                <button className={`${globalStyles.primaryButton} ${styles.desktopButton}`}> {docType === 'scheme' ? `View ${full_name}` : `View details`}</button>
                <button className={`${globalStyles.primaryButton} ${styles.mobileButton}`}> View details</button>
              </Link>
            )}
            {properties && properties.length > 0 && (
              <>
                {displayExpandButton && (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      if (selected !== id) {
                        onExpand(id);
                      } else {
                        onExpand(null);
                      }
                    }}
                    title="Click to view available properties here"
                    // active={}
                    className={styles.ConcatButton}
                  >
                    {`${selected === id ? "Hide" : "Show"} ${number_of_available_properties} unit details`}
                    <img src={`${process.env.NEXT_PUBLIC_APP_CDN_URL}icons/simplearrow-down-grey.svg`} width="24" height="10" alt="Not Included" className={selected === id ? styles.rotate : ''} />
                  </button>
                )}
                {!displayExpandButton && (
                  <div className={styles.amount}>{number_of_available_properties} available units</div>
                )}
              </>
            )}
          </div>


        </div >
      </div >
    </li >


  );
};


export default DisplayCard;
